import React from 'react';
import './NavbarBrandLogo.css';

/** Logo from `public/logo.png` (served at /logo.png). */
const NavbarBrandLogo: React.FC = () => {
  const base = process.env.PUBLIC_URL || '';
  return (
    <img
      src={`${base}/logo.png`}
      alt=""
      className="navbar-brand-logo me-2"
      width={50}
      height={50}
      decoding="async"
    />
  );
};

export default NavbarBrandLogo;
